import React from 'react';
import { LeadTypeBadge } from '../LeadTypeBadge';

export const AdminPanelLeadsTab = ({ leads, vendedores, handleDeleteLead }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm p-6" data-testid="admin-panel-leads-tab">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Todos os Leads</h2>
      {leads.length === 0 ? (
        <p className="text-gray-500" data-testid="admin-panel-leads-empty">Nenhum lead cadastrado.</p>
      ) : (
        <div className="space-y-4" data-testid="admin-panel-leads-list">
          {leads.map((lead) => {
            const vendedor = vendedores.find((item) => item.id === lead.vendedor_id);

            return (
              <div key={lead.id} className="border border-gray-200 rounded-xl p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-testid={`admin-panel-lead-card-${lead.id}`}>
                <div>
                  <p className="font-semibold text-gray-900">{lead.cliente_nome}</p>
                  <p className="text-sm text-gray-600">{lead.cliente_email}</p>
                  {lead.cliente_telefone && <p className="text-sm text-gray-500">{lead.cliente_telefone}</p>}
                  <p className="text-xs text-gray-400 mt-2">
                    Vendedor: {vendedor?.nome || lead.vendedor_codigo} • {new Date(lead.created_at).toLocaleString('pt-BR')}
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <LeadTypeBadge type={lead.tipo} className="px-3 py-1 rounded-full text-xs font-medium" />
                  <button
                    type="button"
                    onClick={() => handleDeleteLead(lead)}
                    className="px-4 py-2 rounded-lg bg-red-50 text-red-700 hover:bg-red-100 transition"
                    data-testid={`admin-panel-delete-lead-button-${lead.id}`}
                  >
                    Excluir
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
